import loadable from "@loadable/component";

import friendsSubcontainers from "./Friends/containers";

const Profile = loadable(() => import("./Profile/Profile"));
const Gallery = loadable(() => import("./Gallery/Gallery"), {
	ssr: false,
});
const Friends = loadable(() => import("./Friends/Friends"), { ssr: false });

export default [
	{
		key: "userProfile",
		component: Profile,
		path: "/users/:login",
		exact: true,
	},
	{
		key: "userGallery",
		component: Gallery,
		path: "/users/:login/gallery",
	},
	{
		key: "userFriends",
		component: Friends,
		path: "/users/:login/friends",
		routes: friendsSubcontainers,
	},
];
